module.exports = __webpack_public_path__ + "static/media/img3-3.fc0bdfab.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/banano/nutricheck_suelo/K/img3-3.png
// module id = 1230
// module chunks = 3